<template>
  <div class="mb-10">
    <skr-heading level="1" data-cy="biz_name">{{ companyName }}</skr-heading>
    <skr-heading level="2">{{ $t('business.profile.subtitle') }}</skr-heading>
  </div>
  <business-id-copy :id="businessId" />
  <p class="mb-4">
    <strong>{{ $t('business.profile.company.card_label') }}</strong>
  </p>
  <business-info-edit :params="{ name: true, phone: true }" />
  <version-indicator />
  <template v-if="showSupportContactForm">
    <strong class="d-block my-4">{{ $t('business.profile.support_contact.card_label') }}</strong>
    <support-contact-edit />
  </template>
</template>

<script lang="ts">
import BusinessIdCopy from '@/components/business/BusinessIdCopy.vue'
import BusinessInfoEdit from '@/components/business/BusinessInfoEdit.vue'
import SupportContactEdit from '@/components/business/SupportContactEdit.vue'
import SkrHeading from '@/components/SkrHeading.vue'
import VersionIndicator from '@/components/VersionIndicator.vue'

export default defineComponent({
  components: {
    SkrHeading,
    BusinessIdCopy,
    BusinessInfoEdit,
    VersionIndicator,
    SupportContactEdit,
  },
  setup() {
    definePageMeta({
      layout: 'admin',
      admin: {
        subNavType: 'business-profile',
      },
      accessControl: {
        roles: ['admin'],
        featureFlags: ['permission.admin.dashboard.view'],
      },
    })

    const businessStore = useBusinessStore()

    const { activePricePlanId } = useUserPlanInfo()

    const { name: companyName, id: businessId, isTrialing } = storeToRefs(businessStore)

    const showSupportContactForm = computed(() => {
      return (
        isTrialing.value ||
        activePricePlanId.value === 'TEAM_V1' ||
        activePricePlanId.value === 'PRO_V1' ||
        activePricePlanId.value === 'SCALE'
      )
    })

    return {
      companyName,
      businessId,
      showSupportContactForm,
    }
  },
  head() {
    return {
      title: 'Business - Profile',
    }
  },
})
</script>
